<button type="button" mat-icon-button [matMenuTriggerFor]="emojiMenu" class="emojiButton" (click)="prepareLazyLoading()">
  <div class="slightly_smiling_face"></div>
  <div class="smiley"></div>
  <!--<mat-icon>emoji_emotions</mat-icon>-->
</button>
<mat-menu class="emoji-panel" #emojiMenu="matMenu">
  <emoji-mart [backgroundImageFn]="backgroundImage" [custom]="CustomEmoji" [categories]="customCategories" [exclude]="excludedCategories" emojiSize="32" isNative="true" (click)="$event.stopPropagation();" (emojiClick)="emojiSelect($event)" showSingleCategory="true"></emoji-mart>
</mat-menu>
